import {
  Box,
  Heading,
  Image,
  Link,
  Text,
  useDisclosure,
  Stack,
  VStack,
} from '@chakra-ui/react';
import { FC, useEffect, useState } from 'react';
import { Modal } from '../../../components';
import { useIsMobile } from '../../../hooks';
import { DownloadSection } from '../components/DownloadSection';

export interface DownloadShareableModalProps {
  previewUrl: string;
  squareUrl: string;
  horizontalUrl: string;
  verticalUrl: string;
  title: string;
  altText: string;
  isOpen: boolean;
  onClosed: () => void;
}

/**
 *  @prop previewUrl string
 *  @prop squareUrl string
 *  @prop horizontalUrl string
 *  @prop verticalUrl string
 *  @prop altName string
 *  @prop isOpen boolean
 *  @prop onClosed()
 */
export const DownloadShareableModal: FC<DownloadShareableModalProps> = ({
  previewUrl,
  squareUrl,
  horizontalUrl,
  verticalUrl,
  title,
  altText,
  isOpen,
  onClosed,
}): JSX.Element => {
  const [internalIsOpen, setInternalIsOpen] = useState<boolean>(isOpen);

  const { onClose } = useDisclosure();
  const isMobile = useIsMobile();
  const guideLinesUrl =
    'https://fundraising.stjude.org/site/DocServer/stjude_diy_guidelines.pdf';
  const legalDisclaimer = `These are owned by St. Jude and your use is permitted for the sole purpose of raising funds and awareness for St. Jude Children’s Research Hospital®.   Images may be used digitally only and cannot be used on any items created for sale. St. Jude retains all rights to the Shareables and the trademarks included within. We may request removal of the images at any time and for any reason. Please see the fundraising guidelines available `;

  useEffect(() => {
    setInternalIsOpen(isOpen);
  }, [isOpen]);

  return (
    <Modal
      isOpen={internalIsOpen}
      onClose={() => {
        setInternalIsOpen(false);
        onClose();
        onClosed();
      }}
      hasPadding={!isMobile}
      size={isMobile ? 'sm' : 'xl'}
    >
      <Stack direction={isMobile ? 'column' : 'row'} spacing={[10, 10, 6]}>
        <Box>
          <Image
            src={previewUrl}
            alt={altText}
            maxW={['100%', '100%', '200px']}
          />
        </Box>
        <VStack spacing={6} pb={6} flex="1">
          <Heading size="sm" color="black" fontWeight="bold">
            Select an image shape to download:
          </Heading>

          <DownloadSection
            imageShape="Square"
            title={title}
            imageUrl={squareUrl}
            socialApps={['Facebook post', 'Instagram post']}
          />
          <DownloadSection
            imageShape="Vertical"
            title={title}
            imageUrl={verticalUrl}
            socialApps={[
              'TikTok post',
              'Instagram Reel',
              'Snapchat Story',
              'YouTube Shorts',
            ]}
          />

          <DownloadSection
            imageShape="Horizontal"
            title={title}
            imageUrl={horizontalUrl}
            socialApps={['Twitter post', 'LinkedIn post']}
          />

          <Text fontStyle="italic" fontSize="sm" alignSelf="flex-start">
            {legalDisclaimer}
            <Link style={{ color: 'blue' }} href={guideLinesUrl}>
              here
            </Link>
          </Text>
        </VStack>
      </Stack>
    </Modal>
  );
};
